// eslint-disable-next-line import/no-self-import
import { isServer } from '@webapp/common/lib/const';

// eslint-disable-next-line import/no-self-import
import type { History } from 'history';
import { createBrowserHistory, createMemoryHistory } from 'history';

// TODO FIXME probably don't needed with next.js
export const history: History = isServer ? createMemoryHistory() : createBrowserHistory();
